import { render, staticRenderFns } from "./UnitPaymentsTable.vue?vue&type=template&id=4e48ba6f&"
import script from "./UnitPaymentsTable.vue?vue&type=script&lang=ts&"
export * from "./UnitPaymentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports